import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Database, Lock } from 'lucide-react';

/**
 * DemoDataGate
 * ============
 * Guards dashboard sections that would otherwise render fabricated/showcase
 * numbers. Real (non-demo) accounts with no live feed NEVER see invented
 * business data — instead they get a compact "connect a data source" prompt
 * for that area (with the promise of real benchmarking once connected).
 *
 *   <DemoDataGate show={isDemoAccount || hasLiveData} title="Executive Summary">
 *     <ExecutiveSummaryGenerator ... />
 *   </DemoDataGate>
 */
export const DemoDataGate = ({ show, title, description, children }) => {
  const navigate = useNavigate();
  if (show) return children;
  return (
    <div className="glass rounded-2xl p-4" data-testid={`demo-data-gate-${(title || 'section').toLowerCase().replace(/[^a-z]+/g, '-')}`}>
      <div className="flex items-center gap-4">
        <div className="w-11 h-11 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-center shrink-0">
          <Lock className="w-5 h-5 text-amber-500" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 truncate">{title}</h3>
          <p className="text-sm text-gray-500 mt-0.5">
            {description || `Connect a data source to unlock ${title} from your live business data — until then we benchmark you against verified industry standards.`}
          </p>
        </div>
        <button
          onClick={() => navigate('/app/integrations')}
          data-testid="gate-connect-data-btn"
          className="inline-flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary/90 transition-colors shrink-0"
        >
          <Database className="w-4 h-4" /> Connect
        </button>
      </div>
    </div>
  );
};

export default DemoDataGate;
